import { prefersLightColorScheme } from './colorScheme.js';

const STORAGE_KEY = 'fluveria-viewport-render-theme';

/** Viewport render theme — independent of the site UI theme. Drives geometry (and later material) rendering. */
export type ViewportRenderTheme = 'system' | 'light' | 'dark';

let current: ViewportRenderTheme = 'system';

export function loadViewportRenderTheme(): void {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === 'system' || raw === 'light' || raw === 'dark') current = raw;
}

export function getViewportRenderTheme(): ViewportRenderTheme {
  return current;
}

export function setViewportRenderTheme(theme: ViewportRenderTheme): void {
  current = theme;
  localStorage.setItem(STORAGE_KEY, theme);
}

/** Resolve `system` against the OS preference; returns a concrete light/dark. */
export function resolveViewportRenderTheme(): 'light' | 'dark' {
  if (current === 'light') return 'light';
  if (current === 'dark') return 'dark';
  return prefersLightColorScheme() ? 'light' : 'dark';
}

/** Numeric encoding for the Theme render node: mode 0/1/2 and resolved theme 0/1 (light/dark). */
export interface RenderThemeValues {
  mode: number;
  resolvedTheme: number;
}

const MODE_INDEX: Record<ViewportRenderTheme, number> = { system: 0, light: 1, dark: 2 };

export function getRenderThemeValues(): RenderThemeValues {
  return {
    mode: MODE_INDEX[current],
    resolvedTheme: resolveViewportRenderTheme() === 'dark' ? 1 : 0,
  };
}
